import request from '@/plugins/request';
import { IStringResult } from '@/types/dto';
import { IOrder } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/my/orders';
const $urlDownload = '/my/orders/actions/download';

interface IGetResult {
  items: IOrder[];
}

interface IDownloadRequest {
  resourceType: string;
  resourceId: string;
}

export default {
  getItems(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  download(req: IDownloadRequest, success: (res: IStringResult) => void) {
    utils.loading(true);
    request
      .post($urlDownload, req)
      .then((response: AxiosResponse<IStringResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
